import {CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import localeRu from '@angular/common/locales/ru';
import {ru} from 'date-fns/locale';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    CORPORATE_THEME,
    COSMIC_THEME,
    DARK_THEME,
    DEFAULT_THEME,
    NB_TIME_PICKER_CONFIG,
    NbDatepickerModule,
    NbDialogModule,
    NbLayoutModule,
    NbMenuModule,
    NbThemeModule,
    NbToastrModule
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {CoreModule} from '@core/core.module';
import {SharedModule} from '@shared/shared.module';
import {HttpClientModule} from '@angular/common/http';
import {registerLocaleData} from '@angular/common';
import {NbDateFnsDateModule} from '@nebular/date-fns';

registerLocaleData(localeRu);

const Locale = {
    provide: LOCALE_ID,
    useValue: 'ru',
};

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        CoreModule,
        HttpClientModule,
        SharedModule,
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NbDatepickerModule.forRoot(),
        NbDateFnsDateModule.forRoot({
            parseOptions: {locale: ru},
            formatOptions: {locale: ru},
            format: 'dd.MM.yyyy'
        }),
        NbDialogModule.forRoot(),
        NbMenuModule.forRoot(),
        NbToastrModule.forRoot({duration: 5000, preventDuplicates: true}),
        NbMenuModule.forRoot(),
        NbThemeModule.forRoot({name: 'default'}),
        NbLayoutModule,
        NbEvaIconsModule,

    ],
    providers: [
        Locale,
        {
            provide: NB_TIME_PICKER_CONFIG,
            useValue: {}
        },
        NbThemeModule.forRoot(
            {
                name: 'default',
            },
            [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME]
        ).providers,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule {
}
